import { render, staticRenderFns } from "./LineItemView.vue?vue&type=template&id=13678735&scoped=true&"
import script from "./LineItemView.vue?vue&type=script&lang=js&"
export * from "./LineItemView.vue?vue&type=script&lang=js&"
import style0 from "./LineItemView.vue?vue&type=style&index=0&id=13678735&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13678735",
  null
  
)

export default component.exports